<template>
    <div :class="{ '--initial': initial }">
        <div v-if="initial" @click.stop="openImportDialog()" name="import-media-btn"
             class="initial-import-media-container">
            <v-icon color="#ababab" size="60" class="material-symbols-outlined">add</v-icon>
            <span class="mt-2">Load Image</span>
        </div>
        <v-btn v-else class="color-gray rounded-xl" outlined @click.stop="openImportDialog()" id="import-media-btn">
            Load Image
        </v-btn>

        <input type="file" @change="startImportProcess" ref="importMedia" id="import-media" multiple />
    </div>
</template>

<script>

import { mapState } from 'vuex';
import { imagesStore } from '@/services/indexedDB.service';
import { cloneDeep } from 'lodash';
import FilenameMixin from '@/mixins/Filename';
import CanMixin from '@/mixins/CanMixin';
import config from '@/assets/js/config/Config'


export default {
    props: {
        initial: Boolean
    },

    data() {
        return {
            firstSwap: true,
        };
    },

    mixins: [FilenameMixin, CanMixin],

    computed: {
        ...mapState('UI', ['startTipsStep']),
        ...mapState('Projects', ['projectTree']),
    },

    async mounted() {
        this.$root.$refs.importMedia = this.$refs.importMedia;
        const interval = setInterval(async () => {
            if (!window.UI || !window.gpu) return;

            clearInterval(interval);
            if (await imagesStore.getItem('media') && this.initial) await this.onMediaSelection();
        }, 1000);
    },

    methods: {
        async openImportDialog() {
            await this.$store.dispatch('App/setAction', {
                name: 'import-media',
                data: {},
            });

            this.$refs.importMedia.click();
            this.$store.dispatch('UI/setStartTipsStep', 2);
        },

        async startImportProcess() {
            if (this.$store.state.App.scriptsLoaded) {
                await loader.uploadImages();
                await this.onMediaSelection();
            }
        },

        async onMediaSelection() {
            if (this.$store.state.App.blockLoading) return;
            if (this.switchingImageInterval) return;

            this.switchingImageInterval = true;
            setTimeout(() => (this.switchingImageInterval = false), 1000);

            const media = await imagesStore.getItem('media');

            this.$store.dispatch('UI/setStartTipsStep', 3);
            this.switchImage(media);
        },

        async switchImage(file) {
            await this.$store.dispatch('File/Media/switch', file);

            $('#wrapper').css('display', 'flex');
            UI.showImageLoader();

            lutify.removeSplitView();
            loader.imageName = this.nicename(file.name);
            this.$store.dispatch('Projects/setActiveCandidate', null);

            let storeData = file;

            await loader.areRequiredFilesLoaded();
            if (!await loader.setActiveMedia(storeData.blob, storeData.fileType, file.id)) return;
            await loader.loadActiveMedia();

            if (loader.typeOfActiveMedia('raw')) {
                UI.showImageLoader(true);
            }

            const lastStateData = await imagesStateStore.getItem('media');
            if (!lastStateData || lastStateData.blocks.length <= 2) {
                for await (const block of config.fixedControlBlocks) {
                    await _Adjustments[block].addBlock();
                }

                lutify.initialBlocks = cloneDeep(lutify.getRawBlocksData());
                await lutify.storeLastState();
            }

            if (!this.firstSwap) {
                await lutify.storeLastState(null, null, loader.previousMedia);
            }

            // updating selected image object
            this.$store.dispatch('Projects/setImage', file.id);
            this.$store.dispatch('Projects/setCurrentFile', file);

            // applying last state
            await lutify.applyLastState(file.id);

            if (!vm.rawDevelopment.updating) {
                UI.hideImageLoader();
            }

            if (this.firstSwap) this.firstSwap = false;

            lutify.switchCandidates();
            await this.$store.dispatch('UserFiles/setLastStatePushInterval');
        },

        nicename(name, stripTimestampOnly = false) {
            if (stripTimestampOnly) return this.stripTimestamp(name);
            else return this.stripTimestampAndExtension(name);
        },
    }
};
</script>

<style lang="scss" scoped>
input {
	display: none;
}

.--initial {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.initial-import-media-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	cursor: pointer;
}
</style>
